export default __webpack_public_path__ + "static/mg-careers-logo-light-9d75d0ab745b076833e5cd3a6579fe9f.svg";